import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import {
  Home,
  Category,
  Animal,
  Search,
  Profile,
  NotFound,
} from '@/pages';
import { AchievementToastContainer } from '@/components/ui/AchievementToast';
import { useAchievementStore } from '@/stores/achievementStore';

// Redirect to launcher for achievements
const LAUNCHER_URL = import.meta.env.VITE_LAUNCHER_URL || 'https://vovan-space.space';

function App() {
  const { pendingAchievements, clearPending } = useAchievementStore();

  return (
    <Layout>
      <AchievementToastContainer
        achievements={pendingAchievements}
        onClear={clearPending}
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:slug" element={<Category />} />
        <Route path="/animal/:slug" element={<Animal />} />
        <Route path="/search" element={<Search />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/achievements" element={<AchievementsRedirect />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

// Redirect to launcher achievements
function AchievementsRedirect() {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token') || localStorage.getItem('session_token') || '';
  window.location.href = `${LAUNCHER_URL}/achievements?token=${token}`;
  return null;
}

export default App;
